import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_PMS_INTEGRATIONS_GET } from 'api/utilityActionTypes';

export default async function getPMSIntegrations(
  { state, utilityApiClient },
  { utilityPartnerId, onSuccess, onError },
) {
  typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_PMS_INTEGRATIONS_GET,
    queryId: `${utilityPartnerId}`,
    state: state,
    payload: {
      utilityPartnerId,
    },
    onSuccess: onSuccess,
    onError: onError,
  });
}
